<template>
    <!-- 拖拽表单组件
         @author liuguisheng
         @date 2019-9-10  
    -->
    <div class="form-wrap"
         @click="onEmptyActive">
      <!-- 空白区域 -->
      <div class="form-empty" 
           v-if="formList.length == 0">请从左侧拖拽或点击添加组件</div>
      <!-- 表单 -->
      <el-form :size="formSettingState.componentSize">
        <draggable class="draggable-wrap" 
                   :value="formList"
                   @input="(v) => formList=v.filter(i=>i)"
                   @add="handleAddFormItem"
                   :options="{
                     group:{name:'draggable_wrap', put:true},
                     ghostClass:'draggable-status_ghost',
                     handle: '.drag-bar'
                   }">
          <form-item-template v-for="(el,i) in formList"  
                              :key="i" 
                              :formNode="el"
                              :formParent="formList">
          </form-item-template>
        </draggable>
      </el-form>
    </div>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixFormMakeChild 表单编辑组件子级混入
 */
import { mixRiceIndexChild } from '@/mixins/rice_index/mix_rice_index_child.js';


export default {
  name: 'FormDraggableContainer',
  mixins: [ mixRiceIndexChild ],
  components: { Draggable: require('vuedraggable') },
  methods: {
    /** @name 添加表单项
     *  @description 设置新表单项为激活状态，通过新表单项索引找到元素更新为激活项
     *  @param {Object} e
     *  - {Number} newIndex 表单项拖拽进来的索引位置
     *  - {Element} item 拖拽的元素对象
     *  @author 王汝鹏
     *  @version 2019-09-22
     */ 
    handleAddFormItem({newIndex, item}) {
      // 模块组件拖拽
      if (item.className.indexOf("domain-component-item") !== -1) { return; }
      // 设置表单激活项
      let formNode = this.formList[newIndex];
      this.formListManager().activeNode(formNode, this.formList);
    },
    /** @name 取消表单激活项
     *  @author 王汝鹏 
     *  @version 2019-12-02
     */
    onEmptyActive() {
      this.formListManager().activeNode({}, []);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Form/FormDraggableContainer.vue